import { breakpoint } from '@carvana/helios-layout';
import { canvas, spacing, text } from '@carvana/helios-styles';
import { body, heading } from '@carvana/helios-typography';
import styled from 'styled-components';

export const Background = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const ContentCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 559px;
  padding: 56px 24px 16px 24px;
  background-color: ${canvas.default};
  box-sizing: border-box;

  ${breakpoint.sm`
    padding: 80px 32px;
    max-width: 959px;
  `}

  ${breakpoint.md`
    padding: 80px 0px 40px 0;
    max-width: 1272px;
  `}
`;

export const Container = styled.div`
  width: 100%;
  ${breakpoint.sm`
    max-width: 959px;
  `}

  ${breakpoint.lg`
    margin: 0px;
    max-width: 1272px;
  `}
`;

export const Header = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 16px;

  ${breakpoint.sm`
    max-width: 400px;
  `}

  ${breakpoint.md`
    ${heading['3Xl']};
    max-width: 624px;
  `}
`;

export const Images = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoint.sm`
    flex-direction: row;
  `}
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing['4Xl']};

  ${breakpoint.sm`
    flex-direction: column;
    margin-bottom: 0;
    max-width: 234px;
  `}

  ${breakpoint.md`
    flex-direction: row;
    margin-bottom: ${spacing['4Xl']};
    max-width: 432px;
  `}
`;

export const ImageWrapper = styled.div`
  flex-grow: 1;
  margin-right: ${spacing['2Xl']};

  & img {
    width: 56px;
    height: 56px;
    border-radius: 8px;
  }
`;

export const BlurbContainer = styled.div`
  flex-grow: 1;

  ${breakpoint.sm`
    margin: ${spacing['2Xl']} ${spacing['2Xl']} 0 0;
  `}

  ${breakpoint.md`
    margin: 0 ${spacing['2Xl']} 0 0;
  `}
`;

export const ImageTitle = styled.h3`
  ${heading.xl};
  color: ${text.strong};
  margin-bottom: 8px;
`;

export const ImageText = styled.p`
  ${body.lg};
  color: ${text.default};
`;

export const TitleText = styled(ImageText)`
  margin-bottom: ${spacing['4Xl']};
  ${body.md}

  ${breakpoint.md`
    ${body.lg}
  `}
`;
